import netsGreetingsAdd from './nets-greetings-add';

export default angular
  .module('app.greetings-add', [])
  .component('netsGreetingsAdd', netsGreetingsAdd);
